import { Tooltip as MUITooltip } from '@mui/material';

export default function Tooltip(props) {
  return (
    <MUITooltip classes={{ tooltip: 'tw-text-sm' }} {...props}>
      {props.children}
    </MUITooltip>
  );
}
